import { z } from "zod";
import { fileUrl } from "./common";

export const SPECIALIZATION_NAME_MAX = 100;
export const SPECIALIZATION_DESCRIPTION_MAX = 500;

const name = z
  .string()
  .trim()
  .min(1, "Naziv je obavezan.")
  .max(SPECIALIZATION_NAME_MAX, `Naziv ne smije biti duži od ${SPECIALIZATION_NAME_MAX} znakova.`);
const description = z
  .string()
  .trim()
  .max(
    SPECIALIZATION_DESCRIPTION_MAX,
    `Opis ne smije biti duži od ${SPECIALIZATION_DESCRIPTION_MAX} znakova.`,
  );
// "" clears the icon; anything else must be an uploaded file or https link.
const iconUrl = fileUrl.or(z.literal(""));

export const createSpecializationSchema = z.object({
  name,
  description: description.optional(),
  iconUrl: iconUrl.optional(),
});

export const updateSpecializationSchema = z.object({
  name: name.optional(),
  description: description.nullable().optional(),
  iconUrl: iconUrl.nullable().optional(),
  isActive: z.boolean().optional(),
});

export const reorderSpecializationsSchema = z.object({
  ids: z
    .array(z.string().min(1))
    .min(1, "Lista za redoslijed je prazna.")
    .max(100, "Može se poredati najviše 100 specijalizacija odjednom."),
});
